export const GAIN_SIGHT_KEY = process.env.REACT_APP_GAIN_SIGHT_KEY;
